import { ConstraintGroupEntity } from "./ConstraintGroupEntity";

export interface CriteriaConstraintGroupUpdateEntity {
    updateGroups: ConstraintGroupEntity[],
    removeGroups: ConstraintGroupEntity[],
}

export const EMPTY_CRITERIA_CONSGRP_UPDATE_ENTITY: CriteriaConstraintGroupUpdateEntity = {
    updateGroups: [],
    removeGroups: []
}